import { get, post } from 'lib/actionHelpers.js';

export const getLeadSearch = ({ serviceProviderId, value }, cbk) => {
  return get(`/service-provider/provider/${serviceProviderId}/search`, {
    query: { value },
    action: 'GET_LEAD_SEARCH',
    callback: cbk,
  });
};

export const getAppSettings = (callback) => {
  return get(`/app/settings`, {
    action: 'GET_APP_SETTINGS',
    alwaysAllowRequest: true,
    callback,
  });
};

export const postRedisDbCacheFlush = () => {
  return post(`/app/flush-redis-db-cache`, {});
};

export const getPipelineTemplates = (callback) => {
  return get(`/pipeline-templates`, {
    action: 'GET_PIPELINE_TEMPLATES',
    callback,
  });
};
